import React from 'react'

interface Props {}

const OrderDetail: React.FC<Props> = () => {
  return <div>OrderDetail</div>
}

export default OrderDetail
